import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASE_FRAGMENT } from '../fragments'

const SAVE_INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES_MUTATION = gql`
  mutation saveIngredientCommonNegativeSynonymPhrases(
    $data: [IngredientCommonNegativeSynonymPhraseInput!]!
  ) {
    saveIngredientCommonNegativeSynonymPhrases(data: $data) {
      results {
        ...IngredientCommonNegativeSynonymPhraseFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default SAVE_INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES_MUTATION
